export default [
    {
        path: '/contacts',
        name: 'contact.user.index',
        component: () => import('@/views/page/Contact/HomeContact.vue'),
        meta: {
            requiresAuth: true,
            layout: 'contact'
        }
    },

    {
        path: '/contacts/my-profile',
        name: 'contact.myProfile.show',
        component: () => import('@/views/page/Contact/ContactMyProfile.vue'),
        meta: {
            requiresAuth: true,
            layout: 'contact'
        }
    },

    {
        path: '/contacts/create-profile',
        name: 'contact.profile.store',
        component: () => import('@/views/page/Contact/ContactProfileForm.vue'),
        meta: {
            requiresAuth: true,
            layout: 'contact'
        }
    },

    {
        path: '/contacts/profile/:contactId/details',
        name: 'contact.profile.details',
        component: () => import('@/views/page/Contact/ContactProfileDetails.vue'),
        meta: {
            requiresAuth: true,
            layout: 'contact'
        }
    },

    {
        path: '/contacts/filter',
        name: 'contact.filter',
        component: () => import('@/views/page/Contact/ContactFilter.vue'),
        meta: {
            requiresAuth: true,
            layout: 'contact'
        }
    },

    /*********************************************
    * Company Contact Routes
    *********************************************/

    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/page/:pageId',
        name: 'contacts-all',
        component: () => import('@/views/page/CompanyContact/HomeContact'),
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/supplier-contacts/:pageId',
        name: 'contacts-supplier',
        component: () => import('@/views/page/CompanyContact/HomeContact'),
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/employee-contacts/:pageId',
        name: 'contacts-employee',
        component: () => import('@/views/page/CompanyContact/HomeContact'),
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/employee-contacts/:pageId',
        name: 'contacts-customer',
        component: () => import('@/views/page/CompanyContact/HomeContact'),
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/member-contacts/:pageId',
        name: 'contacts-member',
        component: () => import('@/views/page/CompanyContact/HomeContact'),
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/contacts-create/:pageId',
        name: 'contacts-create',
        component: () => import('@/views/page/CompanyContact/ContactProfileForm'),
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/contacts-details/:contactId',
        name: 'company.contacts.details',
        component: () => import('@/views/page/CompanyContact/ContactProfileDetails'),
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/contact-register/:pageId',
        component: () => import('@/views/page/company/contact/register/Index.vue'),
        name: 'contact-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/add-contact/:pageId',
        component: () => import('@/views/page/company/contact/Add.vue'),
        name: 'add-contact',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/contact-profile/:pageId',
        component: () => import('@/views/page/company/contact/List.vue'),
        name: 'contact-profile',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/client-register/:pageId',
        component: () => import('@/views/page/company/client-register/List.vue'),
        name: 'client-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/work-status-update/:pageId',
        component: () => import('@/views/page/company/contact/work-status/Update.vue'),
        name: 'work-status-update',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/work-status-report/:pageId',
        component: () => import('@/views/page/company/contact/work-status/WorkStatusReport.vue'),
        name: 'work-status-report',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/my-work-status-report/:pageId',
        component: () => import('@/views/page/company/contact/work-status/MyWorkStatusReport.vue'),
        name: 'my-work-status-report',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/project-timesheet-report/:pageId',
        component: () => import('@/views/page/company/contact/work-status/ProjectTimesheetReport.vue'),
        name: 'project-timesheet-report',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/contact-import/:pageId',
        component: () => import('@/views/page/company/contact/contact-import/ContactImportList.vue'),
        name: 'contact-import',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/upload-contact/:pageId',
        component: () => import('@/views/page/company/contact/contact-import/UploadContact.vue'),
        name: 'upload-contact',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/contact-import-update/:pageId',
        component: () => import('@/views/page/company/contact/contact-import/ContactImportUpdateList.vue'),
        name: 'contact-import-update',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/update-upload-contact/:pageId',
        component: () => import('@/views/page/company/contact/contact-import/UpdateUploadContact.vue'),
        name: 'update-upload-contact',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/supplier-register/:pageId',
        component: () => import('@/views/page/company/supplier-register/register/Index.vue'),
        name: 'supplier-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/add-supplier/:pageId',
        component: () => import('@/views/page/company/supplier-register/Add.vue'),
        name: 'add-supplier',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/supplier-list/:pageId',
        component: () => import('@/views/page/company/supplier-register/List.vue'),
        name: 'supplier-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/customer-register/:pageId',
        component: () => import('@/views/page/company/customer-register/register/Index.vue'),
        name: 'customer-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/add-customer/:pageId',
        component: () => import('@/views/page/company/customer-register/Add.vue'),
        name: 'add-customer',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/customer-list/:pageId',
        component: () => import('@/views/page/company/customer-register/List.vue'),
        name: 'customer-list',
        meta: {
            requiresAuth: true
        }
    },
]
